import 'bootstrap/dist/css/bootstrap.min.css';
import './nsre.css';
import {
  PAGES,
  initialState,
  STATE,
  MOBILE_SESSION_TIMEOUT_DURATION,
  MOBILE_SESSION_TIMEOUT_WARNING_DURATION,
  SESSION_TIMEOUT_DURATION,
  SESSION_TIMEOUT_WARNING_DURATION,
  STORAGE_KEYS, AGENT_INFO, RECOMMENDATION_CODE
} from './scripts/constants';
import {mygaSession, funcDebounce, isValid} from './scripts/myga-session';
import React, {Component} from "react";
import {Container, Button, Modal} from "react-bootstrap";
import Landing from "./pages/Landing/Landing";
import roadImg from './assets/images/openroad.jpg';
import Beneficiary from "./pages/Test/Beneficiary";
import PageHolder from "./components/PageHolder";
import Resources from "./Resources/Resources";
import './myga.css';
import {NassauLog} from "./scripts/myga-utils"

import Dashboard from "./pages/Dashboard/Dashboard";
import ProcessOverview from "./pages/Application/ProcessOverview/ProcessOverview";
import Finances from "./pages/Application/Finances/Finances";
import Goals from "./pages/Application/Goals/Goals";
import Benes from "./pages/Application/Benes/Benes";
import Finalize from "./pages/Application/Finalize/Finalize";
import SubmitApp from "./pages/Application/SubmitApp/SubmitApp";
import AppCompleted from "./pages/Application/AppCompleted/AppCompleted";
import Payments from "./pages/Application/Payments/Payments";

// test pages
import NavBar from "./components/Navigation/NavBar";
import GuestEmail from "./components/test/GuestEmail";
import RateCharts from "./pages/Dashboard/RateCharts";
import TreasuryRateList from "./pages/Dashboard/TreasuryRateList";
import SectionProgress from "./components/SectionProgress";
import CDRateList from "./pages/Dashboard/CDRateList";
import MMRateList from "./pages/Dashboard/MMRateList";
import AppPartialComplete from "./pages/Application/AppPartialComplete/AppPartialComplete";
import IdScan from "./pages/Application/IdScan/IdScan";
import AgentCode from "./pages/Application/AgentCode/AgentCode";
import MailCheckInfo from "./pages/Application/MailCheckInfo/MailCheckInfo";
import ConfirmEFT from "./pages/Application/ConfirmEFT/ConfirmEFT";

// import CONFIG from "./temp/config";
// import {Router, Route, Switch, Redirect} from "react-router-dom";
// import {createBrowserHistory} from "history";

import ScheduleCall from "./pages/Application/ScheduleCall/ScheduleCall";
import {isPathB, isPathC} from "./scripts/validation";
import ProductStore from "./pages/Application/ProductStore/ProductStore";
import {Analytics} from "./scripts/analytics";
import PageTitle from "./components/PageTitle";
import {PageManager} from "./scripts/page-manager";
import FinancesFL from "./pages/Application/Finances/FinancesFL";
import NeedsFL from "./pages/Application/Needs/NeedsFL";
import OwnerAnnuitant from "./pages/Application/IdPages/OwnerAnnuitant";
import OwnerAnnuitantSummary from "./pages/Application/IdPages/OwnerAnnuitantSummary";
import Knockout from "./pages/Application/AppKnockout/Knockout";
import KnockoutLanding from "./pages/Application/AppKnockout/KnockoutLanding";
import AppPartialCompleteAgentRecommendation
  from "./pages/Application/AppPartialComplete/AppPartialCompleteAgentRecommendation";
import {loadMygaRates, loadProductRates} from "./scripts/myga-data";
import FundsFL from "./pages/Application/Funds/FundsFL";

// let history = createBrowserHistory();

// Setup for using FontAwesome Icons if needed.
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faTimes,
  faInfoCircle, faEllipsisH,
  faTimesCircle,
  faPlus,
  faShoppingCart, faStore, faChevronLeft, faChevronRight, faDownload,
  faCircle
} from '@fortawesome/free-solid-svg-icons'
import GeneralFL from "./pages/Application/General/GeneralFL";
import SubmitAppClientFL from "./pages/Application/SubmitApp/SubmitAppClientFL";
import SubmitAppAgentFL from "./pages/Application/SubmitApp/SubmitAppAgentFL";
import GoalsFL from "./pages/Application/Goals/GoalsFL";
import {MM_PRODUCT_FAMILY} from "./scripts/myga-model";
import GENERATOR from "./selenium-front-end/generator/Generator";

// Add FA icons to the library
library.add(faTimes, faInfoCircle, faEllipsisH, faTimesCircle,
    faPlus, faShoppingCart, faStore, faChevronLeft, faChevronRight, faDownload, faCircle);

class App extends Component {
  
  constructor(props) {
    super(props);
    // Listen to browser back/forward buttons
    // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
    // window.onpopstate = e => {
    //   let nextPage = e.target.location.pathname.replace(`/${CONFIG.s3Directory}`, '');
    //   // 2021.02.08.ADivelbiss - Validate the page with the myga session
    //   nextPage = validateDataForPage(nextPage);
    //   history.replace(nextPage);
    //   this.setState({page: nextPage}, () => {
    //     mygaSession.setMygaSessionValue(STATE.page, this.state.page);
    //   })
    // }
    // 2021.02.11.ADivelbiss - end - ROUTING: uncomment when ready to implement routing
    
    // Check for mobile device
    // NassauLog('userAgent: ' + navigator.userAgent);
    
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    NassauLog(`isMobile: ${this.isMobile}`);
    
    this.state = initialState();
    this.modalRef = React.createRef();
    
    this.registerPageFactory();
    
  }
  
  componentDidMount() {
    
    // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
    // let page = window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1);
    // 2021.02.11.ADivelbiss - END - ROUTING: uncomment when ready to implement routing
    
    // 2021.02.11.ADivelbiss - START - ROUTING: comment/remove when ready to implement routing
    let page = mygaSession.getMygaSessionValue(STATE.page,PAGES.pageLanding);
    // 2021.02.11.ADivelbiss - END - ROUTING: comment/remove when ready to implement routing
    
    // 2021.05.21.ADivelbiss - Initialize the analytics data layer.
    Analytics.restart();
    
    // Setup the agent referral/recommendation info
    const params = new URLSearchParams(window.location.search);
    let agentReferralInfo = {};
    let agentReferralCode = params.get('a');
    if (agentReferralCode) {
      // 2021.02.11.ADivelbiss - added try/catch to prevent crash for invalid Base64.
      try {
        agentReferralCode = atob(agentReferralCode);
        agentReferralInfo[AGENT_INFO.referralCode] = agentReferralCode;
      } catch (e) {
        // not a valid code.
      }
    }
    // Check that the agentReferralIfno has a real referral code
    if (agentReferralInfo[AGENT_INFO.referralCode]) {
      
      // 2021.09.29.ADivelbiss - check for a recommendation code and sanitize if present.
      let agentRecommendationCode = params.get('ar') ?
          params.get('ar').replace(/[^\w\s]/g,'') : // sanitize
          RECOMMENDATION_CODE.none;
      NassauLog(`ar: ${params.get('ar')}`);
      
      // 2021.10.06.ADivelbiss - if the given, sanitized code is not a valid code as defined in the RECOMMENDATION_CODE
      // code values then set to RECOMMENDATION_CODE.none .
      // 2021.06.15.ADivelbiss - Add support for recommendation code
      // NOTE this will be a simple code that indicates the type of recommendation
      // if not present then this is a simple referral and not a recommendation.
      // validate the code
      if (!Object.values(RECOMMENDATION_CODE).find(code=>code===agentRecommendationCode)) {
        agentRecommendationCode = RECOMMENDATION_CODE.none;
      }
      NassauLog(`agentRecommendationCode: ${agentRecommendationCode}`);
      agentReferralInfo[AGENT_INFO.recommendationCode] = agentRecommendationCode;
      
      // 2020.03.31.ADivelbiss - Change page for agent referral to the Dashboard per Tisa's request
      page = PAGES.pageDashboard;
      PageManager.setFirstPageOfTest(PAGES.pageDashboard)
    } else {
      PageManager.setFirstPageOfTest(PAGES.pageLanding)
    }
    NassauLog(`agentReferralInfo: ${JSON.stringify(agentReferralInfo,null,2)}`);
    
    // 2021.02.08.ADivelbiss - Validate the page with the myga session
    page = PageManager.validateDataForPage(page);
    
    // get the current page state from the session
    this.setState({
      page,
      agentReferralInfo
    }, () => {
      // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
      // history.push(`/${CONFIG.s3Directory}${this.state.page}`);
      // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
    });
    
  }
  
  componentWillUnmount() {
    this.clearSessionListeners();
  }
  
  resetIdleTimer = () => {
    // NassauLog('reset activity');
    this.clearSessionListeners();
    this.startSessionListeners();
  };
  
  restart = () => {
    // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
    // this.setState(initialState(), () => history.push(`/${CONFIG.s3Directory}${initialState().page}`));
    // 2021.02.11.ADivelbiss - END - ROUTING: uncomment when ready to implement routing
    // 2021.02.11.ADivelbiss - START - ROUTING: comment/remove when ready to implement routing
    this.setState(initialState());
    // 2021.02.11.ADivelbiss - END - ROUTING: comment/remove when ready to implement routing
    
    mygaSession.clearMygaSession();
    mygaSession.setMygaSessionValue(STATE.page, initialState().page);
    
    
    // 2021.05.21.ADivelbiss - Initialize the analytics data layer.
    Analytics.restart();
    
  };
  
  startSessionListeners() {
    let sessionTimeoutWarningListener = funcDebounce(() => this.setState({showTimeoutWarning: true}),
        (this.isMobile?MOBILE_SESSION_TIMEOUT_WARNING_DURATION:SESSION_TIMEOUT_WARNING_DURATION));
    
    // cont timeout =
    
    let sessionTimeoutListener = funcDebounce(() => {
      this.restart();
      this.clearSessionListeners();
    }, (this.isMobile?MOBILE_SESSION_TIMEOUT_DURATION:SESSION_TIMEOUT_DURATION));
    
    this.setState({
      sessionTimeoutWarningListener,
      sessionTimeoutListener
    });
  }
  
  clearSessionListeners() {
    clearTimeout(this.state.sessionTimeoutWarningListener);
    clearTimeout(this.state.sessionTimeoutListener);
  }

  handleAppClick = e => {
    this.resetIdleTimer()

    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      GENERATOR.handleClick(e)
    }
  }
  
  /**
   * Causes the application to move to the next page.
   * If the returnToPage is provided, the nextPage will be configured to return to
   * the specified page.
   * @param nextPage
   * @param returnToPage
   * @param showCancel
   */
  updatePage = (nextPage, returnToPage, showCancel = false) => {
    // NassauLog('page updating to:', nextPage);
    
    // 2021.02.08.ADivelbiss - Validate the page with the myga session
    // NassauLog(`call validateDataForPage: ${nextPage}`);
    nextPage = PageManager.validateDataForPage(nextPage);
    // NassauLog(`returned validateDataForPage: ${nextPage}`);
    
    //************ADD CODE HERE*************//
    //If page is either dashboard or landing page & Rates dont exist, then load rates.
    if (this.state.page === "pageLanding" || this.state.page === "pageDashboard"){
      NassauLog("Either Landing or Dash");
      const currentMygaRates = mygaSession.getMygaRates();
      if(!currentMygaRates){
        loadMygaRates().catch((err)=>{
          NassauLog(err);
        });
      }
      // 2022.05.12.ADivelbiss - load the new rates files for simple an myannuity
      if (!mygaSession.getProductRates(MM_PRODUCT_FAMILY.nfgSA)) {
        loadProductRates(MM_PRODUCT_FAMILY.nfgSA)
            .catch(err=>NassauLog(err));
      }
      if (!mygaSession.getProductRates(MM_PRODUCT_FAMILY.nfgMA)) {
        loadProductRates(MM_PRODUCT_FAMILY.nfgMA)
            .catch(err=>NassauLog(err));
      }
      
    }
    
    // set the current page in the page manager
    PageManager.setCurrentPage(nextPage,returnToPage,showCancel);
    
    this.setState({page: nextPage}, () => {
      
      // 2021.05.17.ADivelbiss - Save the current page to the data layer for GTM
      Analytics.setPage(this.state.page);
      
      // 2021.05.21.ADivelbiss - Add check for pathB
      // 2021.10.07.ADivelbiss - Added check for pathC
      if (isPathC()) {
        Analytics.setSubmissionPathC();
      } else if (isPathB()) {
        Analytics.setSubmissionPathB();
      } else {
        Analytics.setSubmissionPathA();
      }
      
      // 2021.05.17.ADivelbiss - get the maximum session page and update in GTM if needed
      let maxPage = mygaSession.getMygaSessionValue(STORAGE_KEYS.maxPage,PAGES.pageLanding);
      if (PageManager.comparePageDepth(this.state.page,maxPage)>=0) {
        mygaSession.setMygaSessionValue(STORAGE_KEYS.maxPage, this.state.page);
        Analytics.setPageMax(this.state.page);
      }
      
      // 2021.05.17.ADivelbiss - trigger the GTM event for a page change
      Analytics.firePageNavigated();
      
      // 2021.08.10.ADivelbiss - the data parameter is no longer used.
      // if (data) {
      //   let dataKey = Object.keys(data)[0];
      //   mygaSession.setMygaSessionValue(dataKey, JSON.stringify(data[dataKey]));
      // }
      
      // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
      // history.push(`/${CONFIG.s3Directory}${nextPage}`);
      // 2021.02.11.ADivelbiss - END - ROUTING: uncomment when ready to implement routing
    });
  };
  
  handleClose = () => this.setState({showTimeoutWarning: false});
  handleShow = () => this.setState({showTimeoutWarning: true});
  
  renderPage = (page) => {
    
    // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
    // let path = `/${CONFIG.s3Directory}${page}`;
    // 2021.02.11.ADivelbiss - END - ROUTING: uncomment when ready to implement routing
    
    // 2021.07.20.ADivelbiss - get the component from the registered component factory
    let pageFactory = PageManager.pageFactory(page)
    // Check that we got a factory function and if so call it.
    let comp = isValid(pageFactory) ? pageFactory() : null;
    if (!isValid(comp)) {
      // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
      // path = '';
      // 2021.02.11.ADivelbiss - END - ROUTING: uncomment when ready to implement routing
      comp = (<Landing updatePage={this.updatePage}/>);
    }
    
    // 2021.07.20.ADivelbiss - removed the switch statement in favor of the dynamic
    // page factory system above.
    
    // 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing
    // return (
    //     <Route path={path}>
    //       <div className="pageContainer pb-2">
    //         {comp}
    //       </div>
    //     </Route>
    // )
    // 2021.02.11.ADivelbiss - END - ROUTING: uncomment when ready to implement routing
    
    // 2021.02.11.ADivelbiss - START - ROUTING: comment/remove when ready to implement routing
    return (
        <div className="pageContainer pb-2">
          {comp}
        </div>
    )
    // 2021.02.11.ADivelbiss - END - ROUTING: comment/remove when ready to implement routing
  };
  
  render() {
    
    return (
        
        <div className={'mainLayout'}
                   style={{backgroundImage: `linear-gradient(to bottom, var(--BackgroundImageColor) 0%, var(--BackgroundImageColor) 100%), url(${roadImg})`}}
                   onClick={this.handleAppClick}>
  
          <PageTitle page={this.state.page}>Simple Annuity</PageTitle>
          
          <div ref={this.modalRef}>
            <Modal
                show={this.state.showTimeoutWarning}
                onHide={this.handleClose}
                backdrop="static"
                keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Your session is about to end.</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                You've been inactive for awhile. Your session will be reset soon. Click "I'm Here" to continue with
                your current session.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={this.handleClose}>I'm Here</Button>
              </Modal.Footer>
            </Modal>
          </div>
          
          <NavBar updatePage={this.updatePage} currentPage={this.state.page} />
  
          <Container fluid id={'mainContent'} className="mainContent pt-3" >

            <SectionProgress currentPage={this.state.page}  />
            
            {/*  Display the page content */}
            {/* 2021.02.11.ADivelbiss - START - ROUTING: uncomment when ready to implement routing */}
            {/*<Router history={history}>*/}
            {/*  <Switch location={window.location}>*/}
            {/*    {this.renderPage(this.state.page)}*/}
            {/*  </Switch>*/}
            {/*</Router>*/}
            {/* 2021.02.11.ADivelbiss - END - ROUTING: uncomment when ready to implement routing */}
            
            {/* 2021.02.11.ADivelbiss - START - ROUTING: comment/remove when ready to implement routing */}
            {this.renderPage(this.state.page)}
            {/* 2021.02.11.ADivelbiss - END - ROUTING: comment/remove when ready to implement routing */}
          
          </Container>
        </div>
    );
  }
  
  /**
   * 2021.07.20.ADivelbiss - This method replaces the switch statement used to generate components for
   * each page.
   */
  registerPageFactory = () => {
    
    // Standard page factory functions
    PageManager.registerPageFactory(PAGES.pageLanding,()=>(
        <Landing updatePage={this.updatePage}/>
    ));
    PageManager.registerPageFactory(PAGES.pageDashboard,()=>(
        <PageHolder pageHeader={'Dashboard'}>
          <Dashboard updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.dashboardFullPages.pageRateCharts,()=>(
        <RateCharts updatePage={this.updatePage}/>
    ));
    PageManager.registerPageFactory(PAGES.dashboardFullPages.pageTreasuryBillRateList,()=>(
        <TreasuryRateList type={'bill'} updatePage={this.updatePage}/>
    ));
    PageManager.registerPageFactory(PAGES.dashboardFullPages.pageTreasuryNoteRateList,()=>(
        <TreasuryRateList type={'note'} updatePage={this.updatePage}/>
    ));
    PageManager.registerPageFactory(PAGES.dashboardFullPages.pageBankCDRateList,()=>(
        <CDRateList updatePage={this.updatePage}/>
    ));
    PageManager.registerPageFactory(PAGES.dashboardFullPages.pageMoneyMarketRateList,()=>(
        <MMRateList updatePage={this.updatePage}/>
    ));
    PageManager.registerPageFactory(PAGES.pageAppProcessOverview,()=>(
        <PageHolder pageHeader={Resources.Strings.ProcessOverview_ItemsTitle}>
          <ProcessOverview updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppPremium,()=>(
        <PageHolder pageHeader={Resources.Strings.Store_HeaderText}>
          <ProductStore updatePage={this.updatePage}/>
        </PageHolder>
    ))
    PageManager.registerPageFactory(PAGES.pageAppFinances,()=>(
        <PageHolder pageHeader={Resources.Strings.Finances_HeaderText} >
          <Finances updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppGoals,()=>(
        <PageHolder pageHeader={Resources.Strings.Goals_HeaderText} >
          <Goals updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppIdOwnerAnnuitant,()=>(
        <PageHolder pageHeader={Resources.Strings.IdDataEntry_HeaderText}>
          <OwnerAnnuitant updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppIdOwnerJoint,()=>(
        <PageHolder pageHeader={Resources.Strings.IdDataEntry_HeaderText}>
          <OwnerAnnuitant isJoint={true} isAnnuitant={false} updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppIdAnnuitant,()=>(
        <PageHolder pageHeader={Resources.Strings.IdDataEntry_HeaderText}>
          <OwnerAnnuitant isJoint={false} isAnnuitant={true} updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppIdAnnuitantJoint,()=>(
        <PageHolder pageHeader={Resources.Strings.IdDataEntry_HeaderText}>
          <OwnerAnnuitant isJoint={true} isAnnuitant={true} updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppIdOwnerAnnuitantSummary,()=>(
        <PageHolder pageHeader={Resources.Strings.IdDataEntry_HeaderText}>
          <OwnerAnnuitantSummary updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppIdScan,()=>(
        <PageHolder pageHeader={'ID Scan'}>
          <IdScan updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppBenes,()=>(
        <PageHolder pageHeader={Resources.Strings.Benes_HeaderText}>
          <Benes updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppPayments,()=>(
        <PageHolder pageHeader={Resources.Strings.Payments_HeaderText}>
          <Payments updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppFinalize,()=>(
        <PageHolder pageHeader={Resources.Strings.Finalize_HeaderText}>
          <Finalize updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppSubmitApp,()=>(
        <PageHolder pageHeader={Resources.Strings.SubmitApp_HeaderText}>
          <SubmitApp updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppCompleted,()=>(
        <PageHolder pageHeader={Resources.Strings.AppCompleted_HeaderText}>
          <AppCompleted updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppPartialComplete,()=>(
        <PageHolder pageHeader={Resources.Strings.AppCompleted_HeaderText}>
          <AppPartialComplete updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppPartialCompleteAR,()=>(
        <PageHolder pageHeader={Resources.Strings.AppCompleted_HeaderText}>
          <AppPartialCompleteAgentRecommendation updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageBenes,()=>(
        <PageHolder pageHeader={'Who will be your beneficiaries?'}>
          <Beneficiary updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageGuestEmail,()=>(
        <PageHolder pageHeader={'Welcome!'}>
          <GuestEmail agentReferralInfo={this.state.agentReferralInfo} updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAgentCode,()=>(
        <PageHolder pageHeader={'Welcome!'}>
          <AgentCode agentReferralInfo={this.state.agentReferralInfo}  updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppMailCheckInfo,()=>(
        <PageHolder pageHeader={'Where do I send payment?'}>
          <MailCheckInfo updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppConfirmEFT,()=>(
        <PageHolder pageHeader={'EFT Authorization'}>
          <ConfirmEFT updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageScheduleCall,()=>(
        <PageHolder pageHeader={'Schedule a Call'}>
          <ScheduleCall updatePage={this.updatePage}/>
        </PageHolder>
    ));
    
    // Knockout page updates
    PageManager.registerPageFactory(PAGES.pageAppKnockout,()=>(
        <PageHolder pageHeader={"Let's Get Started"}>
          <Knockout updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppKnockoutLanding,()=>(
        <PageHolder pageHeader={"Let's Get Started"}>
          <KnockoutLanding updatePage={this.updatePage}/>
        </PageHolder>
    ));
    
    // Florida page updates
    PageManager.registerPageFactory(PAGES.pageAppFinancesFL,()=>(
        <PageHolder pageHeader={Resources.Strings.Finances_HeaderText} showGlossaryModalLink={'Show'}>
          <FinancesFL updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppNeedsFL,()=>(
        <PageHolder pageHeader={'What are your Needs?'} showGlossaryModalLink={'Show'}>
          <NeedsFL updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppGoalsFL,()=>(
        <PageHolder pageHeader={'Goals'} showGlossaryModalLink={'Show'}>
          <GoalsFL updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppFundsFL,()=>(
        <PageHolder pageHeader={'What Are Your Plans?'} showGlossaryModalLink={'Show'}>
          <FundsFL updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppGeneralFL,()=>(
        <PageHolder pageHeader={'General'}>
          <GeneralFL updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppSubmitAppClientFL,()=>(
        <PageHolder pageHeader={'Submit App Client'}>
          <SubmitAppClientFL updatePage={this.updatePage}/>
        </PageHolder>
    ));
    PageManager.registerPageFactory(PAGES.pageAppSubmitAppAgentFL,()=>(
        <PageHolder pageHeader={'Submit App Agent'}>
          <SubmitAppAgentFL updatePage={this.updatePage}/>
        </PageHolder>
    ));
  }
  
}

export default App;
